import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { IssueWarrantyDTO, IssueWarrantyQueryParams, RegisterWarrantyContractAmountRequest, RequestPutWarrantieBuild, ResponsePutWarrantieBuild } from '../warranties/interfaces/warranty.interface';
import { environment } from 'src/environments/enviroments';
import { ActionResponseDTO } from 'src/app/common/interfaces/action-result.interface';

@Injectable({
  providedIn: 'root'
})
export class WarrantiesService {

  constructor(private httpClient: HttpClient) { }

  getIssueWarranties(queryParam: IssueWarrantyQueryParams): Observable<PageResult<IssueWarrantyDTO>>{
    const { start, end, page, pageSize, sortColumn, sortDirection, search } = queryParam
    let params = new HttpParams()
    .set('start', start ? start.toISOString() : '')
    .set('end', end ? end.toISOString() : '')
    .set('page', page)
    .set('pageSize', pageSize)
    .set('sortColumn', sortColumn ||'')
    .set('sortDirection', sortDirection ||'')
    .set('search', search || '');

    const endpoint = `${environment.apiUrl}/warranties/issues`;
    return this.httpClient.get<PageResult<IssueWarrantyDTO>>(endpoint, { params: params});
  }

  registerWarrantyContractAmount(request: RegisterWarrantyContractAmountRequest): Observable<ActionResponseDTO<boolean>>{
    const endpoint = `${environment.apiUrl}/warranties/${request.warrantyId}/ContractAmount`;
    return this.httpClient.put<ActionResponseDTO<boolean>>(endpoint, request);
  }

  getEventLogs(warrantyId:number){
    const endpoint = `${environment.apiUrl}/company/${warrantyId}/getLogEventWarranties`;
    return this.httpClient.get<any>(endpoint);
  }

  putWarrantieBuild(request: IssueWarrantyDTO, state: boolean) {
    const endpoint = `${environment.apiUrl}/warranties/WarrantieConstruccion`;
    const requestBody = {
      warrantyId: request.warrantyId,
      isConstruccion: state
    };
    return this.httpClient.put<ResponsePutWarrantieBuild>(endpoint, requestBody);
  }

  putWarrantiesBuild(request: RequestPutWarrantieBuild[]) {
    console.log(request);
    const endpoint = `${environment.apiUrl}/warranties/WarrantiesConstruccion`;
    return this.httpClient.put<ResponsePutWarrantieBuild>(endpoint, request);
  }

}